import { KioskPaymentTerminalState } from './kiosk_payment_terminal_state.js';

export function name(paymentTerminalState: KioskPaymentTerminalState): string {
  switch (paymentTerminalState) {
    case KioskPaymentTerminalState.STOPPED:
      return 'stopped';
    case KioskPaymentTerminalState.INITIALIZING:
      return 'initializing';
    case KioskPaymentTerminalState.TERMINAL_SELECTION:
      return 'terminal selection';
    case KioskPaymentTerminalState.WAITING_FOR_TERMINAL:
      return 'waiting for terminal';
    case KioskPaymentTerminalState.CONNECTING:
      return 'terminal connecting';
    case KioskPaymentTerminalState.UPDATING:
      return 'updating';
    case KioskPaymentTerminalState.READY:
      return 'ready';
    case KioskPaymentTerminalState.TRANSACTION:
      return 'transaction';
  }
}
